import { render, staticRenderFns } from "./AddQualificationSettings.vue?vue&type=template&id=0b551083&scoped=true"
import script from "./AddQualificationSettings.vue?vue&type=script&lang=js"
export * from "./AddQualificationSettings.vue?vue&type=script&lang=js"
import style0 from "./AddQualificationSettings.vue?vue&type=style&index=0&id=0b551083&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b551083",
  null
  
)

export default component.exports